import { Button } from "react-bootstrap";
import styles from "./upload-progress.module.scss";
import { Icon } from "../index";

type UploadProgressItemProps = {
  progress: number;
  name: string;
  size: number;
  onCancel: (name: string) => void;
};

const UploadProgressItem = ({
  progress,
  name,
  size,
  onCancel
}: UploadProgressItemProps) => {
  const isFinished = progress === 100;
  return (
    <li
      className={`${styles["progress-item"]} ${
        isFinished
          ? styles["progress-item-success"]
          : styles["progress-item-progress"]
      }`}
    >
      <div className={styles["progress-bar"]} style={{ height: 0 }}>
        <span
          className={styles["progress-bar-inner"]}
          style={{ width: `${progress + 1}%` }}
        />
      </div>
      <span className={styles["progress-item-group-wrapper"]}>
        {isFinished ? (
          <Icon name="file-extension-wrapper" />
        ) : (
          <Icon name="upload-files" />
        )}
      </span>
      <span className={styles["progress-item-file-name-wrapper"]}>
        <span className={styles["progress-item-file-name"]} title={`${name}`}>
          {name}
        </span>
      </span>
      {!isFinished && (
        <Button
          variant="link"
          onClick={() => onCancel(name)}
          disabled={isFinished}
          className={styles["progress-item-button"]}
        >
          <Icon name="close" />
        </Button>
      )}
    </li>
  );
};

export default UploadProgressItem;
